import { RunVisit } from './RunVisit';
import { RunExtract } from './RunExtract';
import { RunCrawl } from './RunCrawl';
import { RunScrape } from './RunScrape';

export const Run = ({ endpoint, params, ...rest }) => {
  let body;
  switch (endpoint) {
    case 'visit':
      body = <RunVisit params={params} {...rest} />;
      break;
    case 'extract':
      body = <RunExtract params={params} {...rest} />;
      break;
    case 'crawl':
      body = <RunCrawl params={params} {...rest} />;
      break;
    case 'scrape':
      body = <RunScrape params={params} {...rest} />;
      break;
    default:
      body = <div>TODO: {endpoint}</div>;
      break;
  }
  return body;
};
